import React from "react";
import I18n from "i18n-js";

import Select from "../../../../common/components/form/Select";

import { SET_SITE, smallLabelFormInputProps } from "../constants";
import ClientUtils from "../../../../company/utils/ClientUtils";
import { func, shape } from "prop-types";

InstallationEditFormSiteSection.propTypes = {
  state: shape(),
  dispatch: func,
  errors: shape(),
};

export default function InstallationEditFormSiteSection({
  state,
  dispatch,
  errors,
}) {
  return (
    <>
      <div className="detail-header">
        <div>{I18n.t("pages.installations.view.site:header")}</div>
        <div className="detail-header-band"></div>
      </div>

      <Select
        id="site"
        onChange={(event) =>
          dispatch({ type: SET_SITE, payload: event.target.value })
        }
        label={I18n.t("pages.installations.view.site:label")}
        renderOption={(option) => (
          <option key={option.uuid} value={option.uuid}>
            {option.designation}
          </option>
        )}
        defaultValue={state.site}
        options={state.siteOptions}
        placeholder={I18n.t(
          "pages.plannedInterventions.create.form.site:placeholder"
        )}
        disabled={!state.client}
        error={errors.site}
        {...smallLabelFormInputProps}
      />
      {state.siteInfos ? (
        <dl className="row align-center">
          <dt className="col-sm-3">
            {I18n.t("pages.installations.view.site-address:label")}
          </dt>
          <dd className="col-sm-9">
            {ClientUtils.renderAddress(state.siteInfos.address)}
          </dd>

          <dt className="col-sm-3">
            {I18n.t("pages.installations.view.siret:label")}
          </dt>
          <dd className="col-sm-9">{state.siteInfos.siret}</dd>
        </dl>
      ) : null}
    </>
  );
}
